import "bootstrap/dist/css/bootstrap.min.css";
import "./IndustriesSec2.css";
import { useLocation } from "react-router-dom";

// ⭐ IMPORT ALL ENGLISH DATA
import {
  defaultHeading,
  financialServicesHeading,
  healthcareHeading,
  lifeScienceHeading,
  defaultStats,
  defaultBlueContent,
  healthcareStats,
  healthcareBlueContent,
  assetManagementStats,
  assetManagementBlueContent,
  bankingStats,
  bankingBlueContent,
  financialAdvisoryStats,
  financialAdvisoryBlueContent,
  financialServiceTaxStats,
  financialServiceTaxBlueContent,
  fintechStats,
  fintechBlueContent,
  insuranceStats,
  insuranceBlueContent,
  oilAndGasStats,
  oilAndGasBlueContent,
  powerAndUtilitiesStats,
  powerAndUtilitiesBlueContent,
  wasteManagementStats,
  wasteManagementBlueContent,
  miningAndMineralsStats,
  miningAndMineralsBlueContent,
  lifeScienceStats,
  lifeScienceBlueContent,
  privateEquityHeading,
  privateEquityStats,
  privateEquityBlueContent,
  professionalServiceHeading,
  professionalServiceStats,
  professionalServiceBlueContent,
  publicSectorBlueContent,
  publicSectorBlueContentStats,
  publicSectorBlueContentHeading,
  realEstateConstructionBlueHeading,
  realEstateConstructionBlueStats,
  realEstateConstructionBlueContent,
  mediaEntertainmentHeading,
  mediaEntertainmentStats,
  mediaEntertainmentBlueContent,
  technologyHeading,
  technologyStats,
  technologyBlueContent,
  telecommunicationHeading,
  telecommunicationStats,
  telecommunicationBlueContent
} from "../../../Data/IndustriesSec2Data";

// ⭐ IMPORT FRENCH DATA
import {
  defaultHeading as defaultHeadingFR,
  financialServicesHeading as financialServicesHeadingFR,
  healthcareHeading as healthcareHeadingFR,
  lifeScienceHeading as lifeScienceHeadingFR,
  defaultStats as defaultStatsFR,
  defaultBlueContent as defaultBlueContentFR,
  healthcareStats as healthcareStatsFR,
  healthcareBlueContent as healthcareBlueContentFR,
  assetManagementStats as assetManagementStatsFR,
  assetManagementBlueContent as assetManagementBlueContentFR,
  bankingStats as bankingStatsFR,
  bankingBlueContent as bankingBlueContentFR,
  financialAdvisoryStats as financialAdvisoryStatsFR,
  financialAdvisoryBlueContent as financialAdvisoryBlueContentFR,
  financialServiceTaxStats as financialServiceTaxStatsFR,
  financialServiceTaxBlueContent as financialServiceTaxBlueContentFR,
  fintechStats as fintechStatsFR,
  fintechBlueContent as fintechBlueContentFR,
  insuranceStats as insuranceStatsFR,
  insuranceBlueContent as insuranceBlueContentFR,
  oilAndGasStats as oilAndGasStatsFR,
  oilAndGasBlueContent as oilAndGasBlueContentFR,
  powerAndUtilitiesStats as powerAndUtilitiesStatsFR,
  powerAndUtilitiesBlueContent as powerAndUtilitiesBlueContentFR,
  wasteManagementStats as wasteManagementStatsFR,
  wasteManagementBlueContent as wasteManagementBlueContentFR,
  miningAndMineralsStats as miningAndMineralsStatsFR,
  miningAndMineralsBlueContent as miningAndMineralsBlueContentFR,
  lifeScienceStats as lifeScienceStatsFR,
  lifeScienceBlueContent as lifeScienceBlueContentFR,
  privateEquityHeading as privateEquityHeadingFR,
  privateEquityStats as privateEquityStatsFR,
  privateEquityBlueContent as privateEquityBlueContentFR,
  professionalServiceHeading as professionalServiceHeadingFR,
  professionalServiceStats as professionalServiceStatsFR,
  professionalServiceBlueContent as professionalServiceBlueContentFR,
  publicSectorBlueContent as publicSectorBlueContentFR,
  publicSectorBlueContentStats as publicSectorBlueContentStatsFR,
  publicSectorBlueContentHeading as publicSectorBlueContentHeadingFR,
  realEstateConstructionBlueHeading as realEstateConstructionBlueHeadingFR,
  realEstateConstructionBlueStats as realEstateConstructionBlueStatsFR,
  realEstateConstructionBlueContent as realEstateConstructionBlueContentFR,
  mediaEntertainmentHeading as mediaEntertainmentHeadingFR,
  mediaEntertainmentStats as mediaEntertainmentStatsFR,
  mediaEntertainmentBlueContent as mediaEntertainmentBlueContentFR,
  technologyHeading as technologyHeadingFR,
  technologyStats as technologyStatsFR,
  technologyBlueContent as technologyBlueContentFR,
  telecommunicationHeading as telecommunicationHeadingFR,
  telecommunicationStats as telecommunicationStatsFR,
  telecommunicationBlueContent as telecommunicationBlueContentFR
} from "../../../Data/French/IndustriesSec2DataFR";

export default function IndustriesSec2({ currentLanguage = "en" }) {
  const location = useLocation();
  const isFrench = currentLanguage === "fr";

  // =========================== DATA SELECTION
  const languageData = {
    defaultHeading: isFrench ? defaultHeadingFR : defaultHeading,
    financialServicesHeading: isFrench ? financialServicesHeadingFR : financialServicesHeading,
    healthcareHeading: isFrench ? healthcareHeadingFR : healthcareHeading,
    lifeScienceHeading: isFrench ? lifeScienceHeadingFR : lifeScienceHeading,
    defaultStats: isFrench ? defaultStatsFR : defaultStats,
    defaultBlueContent: isFrench ? defaultBlueContentFR : defaultBlueContent,
    healthcareStats: isFrench ? healthcareStatsFR : healthcareStats,
    healthcareBlueContent: isFrench ? healthcareBlueContentFR : healthcareBlueContent,
    assetManagementStats: isFrench ? assetManagementStatsFR : assetManagementStats,
    assetManagementBlueContent: isFrench ? assetManagementBlueContentFR : assetManagementBlueContent,
    bankingStats: isFrench ? bankingStatsFR : bankingStats,
    bankingBlueContent: isFrench ? bankingBlueContentFR : bankingBlueContent,
    financialAdvisoryStats: isFrench ? financialAdvisoryStatsFR : financialAdvisoryStats,
    financialAdvisoryBlueContent: isFrench ? financialAdvisoryBlueContentFR : financialAdvisoryBlueContent,
    financialServiceTaxStats: isFrench ? financialServiceTaxStatsFR : financialServiceTaxStats,
    financialServiceTaxBlueContent: isFrench ? financialServiceTaxBlueContentFR : financialServiceTaxBlueContent,
    fintechStats: isFrench ? fintechStatsFR : fintechStats,
    fintechBlueContent: isFrench ? fintechBlueContentFR : fintechBlueContent,
    insuranceStats: isFrench ? insuranceStatsFR : insuranceStats,
    insuranceBlueContent: isFrench ? insuranceBlueContentFR : insuranceBlueContent,
    oilAndGasStats: isFrench ? oilAndGasStatsFR : oilAndGasStats,
    oilAndGasBlueContent: isFrench ? oilAndGasBlueContentFR : oilAndGasBlueContent,
    powerAndUtilitiesStats: isFrench ? powerAndUtilitiesStatsFR : powerAndUtilitiesStats,
    powerAndUtilitiesBlueContent: isFrench ? powerAndUtilitiesBlueContentFR : powerAndUtilitiesBlueContent,
    wasteManagementStats: isFrench ? wasteManagementStatsFR : wasteManagementStats,
    wasteManagementBlueContent: isFrench ? wasteManagementBlueContentFR : wasteManagementBlueContent,
    miningAndMineralsStats: isFrench ? miningAndMineralsStatsFR : miningAndMineralsStats,
    miningAndMineralsBlueContent: isFrench ? miningAndMineralsBlueContentFR : miningAndMineralsBlueContent,
    lifeScienceStats: isFrench ? lifeScienceStatsFR : lifeScienceStats,
    lifeScienceBlueContent: isFrench ? lifeScienceBlueContentFR : lifeScienceBlueContent,
    privateEquityHeading: isFrench ? privateEquityHeadingFR : privateEquityHeading,
    privateEquityStats: isFrench ? privateEquityStatsFR : privateEquityStats,
    privateEquityBlueContent: isFrench ? privateEquityBlueContentFR : privateEquityBlueContent,
    professionalServiceHeading: isFrench ? professionalServiceHeadingFR : professionalServiceHeading,
    professionalServiceStats: isFrench ? professionalServiceStatsFR : professionalServiceStats,
    professionalServiceBlueContent: isFrench ? professionalServiceBlueContentFR : professionalServiceBlueContent,
    publicSectorBlueContentHeading: isFrench ? publicSectorBlueContentHeadingFR : publicSectorBlueContentHeading,
    publicSectorBlueContentStats: isFrench ? publicSectorBlueContentStatsFR : publicSectorBlueContentStats,
    publicSectorBlueContent: isFrench ? publicSectorBlueContentFR : publicSectorBlueContent,
    realEstateConstructionBlueHeading: isFrench ? realEstateConstructionBlueHeadingFR : realEstateConstructionBlueHeading,
    realEstateConstructionBlueStats: isFrench ? realEstateConstructionBlueStatsFR : realEstateConstructionBlueStats,
    realEstateConstructionBlueContent: isFrench ? realEstateConstructionBlueContentFR : realEstateConstructionBlueContent,
    mediaEntertainmentHeading: isFrench ? mediaEntertainmentHeadingFR : mediaEntertainmentHeading,
    mediaEntertainmentStats: isFrench ? mediaEntertainmentStatsFR : mediaEntertainmentStats,
    mediaEntertainmentBlueContent: isFrench ? mediaEntertainmentBlueContentFR : mediaEntertainmentBlueContent,
    technologyHeading: isFrench ? technologyHeadingFR : technologyHeading,
    technologyStats: isFrench ? technologyStatsFR : technologyStats,
    technologyBlueContent: isFrench ? technologyBlueContentFR : technologyBlueContent,
    telecommunicationHeading: isFrench ? telecommunicationHeadingFR : telecommunicationHeading,
    telecommunicationStats: isFrench ? telecommunicationStatsFR : telecommunicationStats,
    telecommunicationBlueContent: isFrench ? telecommunicationBlueContentFR : telecommunicationBlueContent,
  };

  // =========================== PATH CHECKS (same as before)
  const isOilAndGas = location.pathname === "/industries/naturalresourcesandenergy/oilandgas";
  const isPowerAndUtilities = location.pathname === "/industries/naturalresourcesandenergy/powerandutilities";
  const isWasteManagement = location.pathname === "/industries/naturalresourcesandenergy/wastemanagement";
  const isMiningAndMinerals = location.pathname === "/industries/naturalresourcesandenergy/miningandminerals";
  const isAssetManagement = location.pathname === "/industries/financialservices/assetmanagement";
  const isBanking = location.pathname === "/industries/financialservices/banking";
  const isFinancialAdvisory = location.pathname === "/industries/financialservices/financialadvisoryservices";
  const isFinancialServiceTax = location.pathname === "/industries/financialservices/financialservicetax";
  const isFinTech = location.pathname === "/industries/financialservices/fintech";
  const isInsurance = location.pathname === "/industries/financialservices/insurance";
  const isHealthcare = location.pathname === "/industries/healthcare";
  const isLifeScience = location.pathname === "/industries/lifescience";
  const isPrivateEquity = location.pathname === "/industries/privateequity";
  const isProfessionalService = location.pathname === "/industries/professionalservice";
  const isPublicSector = location.pathname === "/industries/publicsector";
  const isRealEstateConstruction = location.pathname === "/industries/realestateconstruction";
  const isMediaEntertainment = location.pathname === "/industries/technologymediaentertainmenttelecommunications/mediaandentertainment";
  const isTechnology = location.pathname === "/industries/technologymediaentertainmenttelecommunications/technology";
  const isTelecommunication = location.pathname === "/industries/technologymediaentertainmenttelecommunications/telecommunication";

  // =========================== HEADING
  let heading = languageData.defaultHeading;

  if (location.pathname.startsWith("/industries/financialservices")) heading = languageData.financialServicesHeading;
  if (isHealthcare) heading = languageData.healthcareHeading;
  if (isLifeScience) heading = languageData.lifeScienceHeading;
  if (isPrivateEquity) heading = languageData.privateEquityHeading;
  if (isProfessionalService) heading = languageData.professionalServiceHeading;
  if (isPublicSector) heading = languageData.publicSectorBlueContentHeading;
  if (isRealEstateConstruction) heading = languageData.realEstateConstructionBlueHeading;
  if (isMediaEntertainment) heading = languageData.mediaEntertainmentHeading;
  if (isTechnology) heading = languageData.technologyHeading;
  if (isTelecommunication) heading = languageData.telecommunicationHeading;

  // =========================== CONTENT MERGE
  let stats = languageData.defaultStats;
  let blueContent = languageData.defaultBlueContent;

  if (isOilAndGas) {
    stats = languageData.oilAndGasStats;
    blueContent = languageData.oilAndGasBlueContent;
  } else if (isPowerAndUtilities) {
    stats = languageData.powerAndUtilitiesStats;
    blueContent = languageData.powerAndUtilitiesBlueContent;
  } else if (isWasteManagement) {
    stats = languageData.wasteManagementStats;
    blueContent = languageData.wasteManagementBlueContent;
  } else if (isMiningAndMinerals) {
    stats = languageData.miningAndMineralsStats;
    blueContent = languageData.miningAndMineralsBlueContent;
  } else if (isAssetManagement) {
    stats = languageData.assetManagementStats;
    blueContent = languageData.assetManagementBlueContent;
  } else if (isBanking) {
    stats = languageData.bankingStats;
    blueContent = languageData.bankingBlueContent;
  } else if (isFinancialAdvisory) {
    stats = languageData.financialAdvisoryStats;
    blueContent = languageData.financialAdvisoryBlueContent;
  } else if (isFinancialServiceTax) {
    stats = languageData.financialServiceTaxStats;
    blueContent = languageData.financialServiceTaxBlueContent;
  } else if (isFinTech) {
    stats = languageData.fintechStats;
    blueContent = languageData.fintechBlueContent;
  } else if (isInsurance) {
    stats = languageData.insuranceStats;
    blueContent = languageData.insuranceBlueContent;
  } else if (isHealthcare) {
    stats = languageData.healthcareStats;
    blueContent = languageData.healthcareBlueContent;
  } else if (isLifeScience) {
    stats = languageData.lifeScienceStats;
    blueContent = languageData.lifeScienceBlueContent;
  } else if (isPrivateEquity) {
    stats = languageData.privateEquityStats;
    blueContent = languageData.privateEquityBlueContent;
  } else if (isProfessionalService) {
    stats = languageData.professionalServiceStats;
    blueContent = languageData.professionalServiceBlueContent;
  } else if (isPublicSector) {
    stats = languageData.publicSectorBlueContentStats;
    blueContent = languageData.publicSectorBlueContent;
  } else if (isRealEstateConstruction) {
    stats = languageData.realEstateConstructionBlueStats;
    blueContent = languageData.realEstateConstructionBlueContent;
  } else if (isMediaEntertainment) {
    stats = languageData.mediaEntertainmentStats;
    blueContent = languageData.mediaEntertainmentBlueContent;
  } else if (isTechnology) {
    stats = languageData.technologyStats;
    blueContent = languageData.technologyBlueContent;
  } else if (isTelecommunication) {
    stats = languageData.telecommunicationStats;
    blueContent = languageData.telecommunicationBlueContent;
  }

  return (
    <div className="">
      {/* Heading */}
      <div className="text-center">
        <h2 className="home-ourprocess-section-head">{heading.title}</h2>
        <h6 className="challenges-subtitle mb-5">{heading.subtitle}</h6>
      </div>

      <section className="proveresultsec position-relative">
        {/* Yellow Stats */}
        <div className="industries-yellow-stats-box">
          <div className="row text-center">
            {stats.map((item, index) => (
              <div
                key={index}
                className="col-6 col-md-3 industries-stats-item"
              >
                <h3>{item.number}</h3>
                <p>{item.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Blue Section */}
        <div className="bluebox-section">
          <div className="row align-items-center">
            <div className="col-md-6 bluebox-leftsection">
              <h2 className="bluesection-title">{blueContent.title}</h2>

              {blueContent.paragraphs.map((para, i) => (
                <p key={i} className="bluesection-para">
                  {para}
                </p>
              ))}

              {blueContent.highlights &&
                blueContent.highlights.length > 0 && (
                  <ul className="custom-list">
                    {blueContent.highlights.map((item, index) => (
                      <li key={index}>
                        <img
                          src={item.icon}
                          alt=""
                          className="indsutries-sec-2-icon"
                        />
                        <span>{item.text}</span>
                      </li>
                    ))}
                  </ul>
                )}
            </div>

            <div className="col-md-6 bluebox-rightsection text-center">
              <img
                src={blueContent.image}
                alt="Industry Content"
                className="Rightsection-img"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
